import vendorA from "./vendors/enabill";
import vendorB from "./vendors/bartone";
import vendorC from "./vendors/milkbun";

const vendors = {
  enabill: vendorA,
  bartone: vendorB,
  milkbun: vendorC
};

const key = process.env.REACT_APP_VENDOR || "enabill"; // default

export default vendors[key];